import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import './styles/admin.css';
import { reportError, startErrorReporting } from './lib/errors';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

startErrorReporting();

// React 19 reports render errors here instead of rethrowing them to `window.onerror`.
createRoot(root, {
  onUncaughtError: error => reportError(error, { source: 'react-uncaught' }),
  onCaughtError: error => reportError(error, { source: 'react-boundary' }),
}).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
